import {versusOnSuit} from './versus';
import {VR} from '../content/lawtables';
import {TPL} from '../content/issues';
import {OUTLETS} from '../content/parties';
import {DI,DM,on} from '../content/settings';
import {structSaldo} from './budget';
import {toast} from './govern';
import {oppParties,press} from './media';
import {rnd} from './rng';
import {demoRevert} from './demo9';
import {woRevert} from './order11';
import {PN,score} from './rules';
import {S,log} from './state';
import {clamp} from './util';
import {since} from './version';


export function vrOf(T?:any,p?:any){if(T.custom)return clamp(T.fx(p||{}).vr||0,0,.9);const f=VR[T.t];return f?clamp(f(p||{}),0,.9):0}
export const vrLabel=(v:any)=>v>=.4?'hoch':v>=.2?'mittel':'gering';
export function fileSuit(L?:any){
  if(!on('court')||L.rep||L.bestand)return;
  const T=TPL(L.iss,L.tpl||0),v=vrOf(T,L.p);if(v<.05)return;
  if(rnd()<Math.min(.95,v*1.8*DM())){
    const opp=oppParties().sort((a:any,b:any)=>score(a,L.fx.pos)-score(b,L.fx.pos));const by=opp[0]||'BU';
    (S.suits=S.suits||[]).push({lid:L.id,t:L.t,by,m:S.m+8+Math.floor(rnd()*6),v});
    log(`${PN(by)} klagt in Karlsruhe gegen „${L.t}“.`,'bad');press(OUTLETS[1].n,`Verfassungsklage gegen „${L.t}“`,-.4)}
}
export function revertLaw(O?:any){
  const f=O.fx,q=O.q||1;
  S.lawB-=(f.b||0);S.lawGr-=(f.gr||0);S.lawAl-=(f.al||0);if(since(8)&&f.gini)S.giniLaw=(S.giniLaw||0)-f.gini*Math.min(1,(O.phase||0)/(O.vn||6));
  demoRevert(O);woRevert(O);
  for(const g in (f.g||{})){const v=f.g[g];S.bonus[g]-=v>0?v*1.3:v}
  if(O.iss&&S.issues[O.iss]){const st=S.issues[O.iss];st.cut=Math.max(0,st.cut-(f.cut||0)*q);st.sev=clamp(st.sev+(f.sev||0)*q*.6,0,100);if(!st.on&&st.sev>=15){st.on=true;st.solved=null}}
  for(const k in (O.rep2||{}))if(S.issues[k])S.issues[k].sev=clamp(S.issues[k].sev+O.rep2[k],0,100);
  if(f.lim)S.limBonus=Math.max(0,(S.limBonus||0)-f.lim);
  S.lte=(S.lte||[]).filter((x:any)=>x.lid!==O.id);S.saldo=structSaldo();
}
export function suitTick(){
  let att=false;S.suits=S.suits||[];
  S.suits=S.suits.filter((x:any)=>{if(S.m<x.m)return true;const O=S.laws.find((l:any)=>l.id===x.lid);
    if(!O||!['kraft','done'].includes(O.stage))return false;
    const pv=clamp(x.v*1.3*[.6,1,1.25][DI()],0,.9)*((S as any).dem?.done?.gericht!=null?.2:1); // Version 11: umgebautes Gericht
    const won=rnd()<pv;if(x.human)versusOnSuit(x.by,won);
    if(won){revertLaw(O);O.stage='void';S.basis-=1;S.partners.forEach((p:any)=>{if(score(p,O.fx.pos)>=.6)S.coal=clamp(S.coal-3,0,100)});
      log(`Karlsruhe erklärt „${O.t}“ für verfassungswidrig. Das Gesetz ist nichtig.`,'bad');press(OUTLETS[0].n,`Ohrfeige aus Karlsruhe: „${O.t}“ verfassungswidrig`,-2);toast(`Karlsruhe kippt „${O.t}“`,'bad')}
    else{S.basis+=.3;log(`Karlsruhe bestätigt „${O.t}“.`,'good');press(OUTLETS[0].n,`Verfassungsgericht bestätigt „${O.t}“`,.8);toast(`Karlsruhe bestätigt „${O.t}“`,'good')}
    att=true;return false});
  return att;
}
